import { render, staticRenderFns } from "./OriginSearch.vue?vue&type=template&id=4a92c68d&scoped=true"
import script from "./OriginSearch.vue?vue&type=script&lang=js"
export * from "./OriginSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a92c68d",
  null
  
)

export default component.exports